export const tableConfig = [
  { id: 1, label: 'User name', isSortable: true, parameter: 'user.firstName' },
  { id: 2, label: 'Time', isSortable: true, parameter: 'createdAtUtc' },
  { id: 3, label: 'Action', isSortable: true, parameter: 'type' },
  { id: 4, label: 'Message', isSortable: false }
];
